import * as React from 'react';

export interface Props {
    isLoading: boolean;
    width?: string;
    children?: React.ReactNode;
}

export default class PlaceholderLoader extends React.Component<Props> {
    render() {
        const { isLoading, children, width } = this.props;

        if (!isLoading) {
            return children || null;
        }

        return (
            <div
                className="placeholder-animated"
                style={{
                    width: width || '100px',
                }}
            >
                -
            </div>
        );
    }
}
